export default __webpack_public_path__ + "static/og-d85d016461263fe102b6c8eb5f25fae8.png";